import styled from 'styled-components'

import { Panel } from '@/ui/atoms/panel'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const LowOrZeroResultsBannerContainer = styled(Panel)(
  ({ theme }) => `
  margin-top: ${theme.spacing.default};
  margin-bottom: ${theme.spacing.default};
  display: flex;
  align-items: flex-start;
  justify-content: left;
  flex-direction: row-reverse;
  background-color: ${theme.colors.purple.light5};
  padding: ${theme.spacing.default};
  & > div {
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-between;
    gap: ${theme.spacing.default};
  }

  // Image should appear mirrored on mobile screens
  img {
    transform: scaleX(-1);
  }

  ${MEDIA_QUERIES(theme).mediumSmall} {
    margin-bottom: ${theme.spacing.large};

    padding: ${theme.spacing.large};
    & > div {
      flex-direction: row;
      justify-content: flex-start;
      & > div {
        max-width: inherit;
      }
    }

    img {
      transform: scaleX(1);
    }
  }

  ${MEDIA_QUERIES(theme).large} {
    margin-bottom: 0;
  }

  `
)
